import Barba from 'barba.js'

export default Barba.BaseView.extend({
    namespace: 'lightbox',
    modal: null,
    callback: null,
    closeCallback: null,
    navigateCallback: null,
    onEnter() {
        this.callback = this.openLightbox.bind(this);
        this.closeCallback = this.closeLightbox.bind(this);
        this.navigateCallback = this.navigateLightbox.bind(this);

        this.modal = document.querySelector('#lightbox-modal');
        this.modal.querySelectorAll('.lightbox-meta .prev, .lightbox-meta .next').forEach( el => el.addEventListener('click', this.navigateCallback ) )
        this.modal.querySelector('.modal-background').addEventListener('click', this.closeCallback);
        this.modal.querySelector('.modal-close').addEventListener('click', this.closeCallback);
        this.image = this.modal.querySelector('img');

        this.thumbnails = document.querySelectorAll('.lightbox a');
        this.thumbnails.forEach( el => el.addEventListener('click', this.callback ) )
    },
    onEnterCompleted() {
    },
    onLeave() {
        this.thumbnails.forEach( el => el.removeEventListener('click', this.callback ) )
        this.modal.querySelector('.modal-background').removeEventListener('click', this.closeCallback);
        this.modal.querySelector('.modal-close').removeEventListener('click', this.closeCallback);
        this.modal = null;
        this.callback = null;
    },
    onLeaveCompleted() {
    },
    closeLightbox( ev ) {
      ev.preventDefault();
      this.modal.classList.remove('is-active');
      this.image.src = '';
    },
    openLightbox( ev ) {
        ev.preventDefault();
        this.image.src = ev.currentTarget.href;
        this.modal.classList.add('is-active');
        this.group = Array.from( document.querySelectorAll( 'a[data-lightbox="'+ev.currentTarget.dataset.lightbox+'"]' ) );
        this.active = this.group.indexOf( ev.currentTarget );
        this.modal.querySelector('p.counter').textContent = `Immagine ${this.active + 1} di ${this.group.length}`;
    },
    navigateLightbox( ev ) {
        ev.preventDefault()
        if( ev.currentTarget.classList.contains( 'prev' ) && this.active === 0 ) return
        if( ev.currentTarget.classList.contains( 'next' ) && this.active === this.group.length - 1 ) return
        let next = ( ev.currentTarget.classList.contains( 'prev' ) ) ? this.active - 1 : this.active + 1;

        this.image.src = this.group[next].href;
        this.active = next;
        this.modal.querySelector('p.counter').textContent = `Immagine ${this.active + 1} di ${this.group.length}`;
    }
})